// extracted by mini-css-extract-plugin
module.exports = {"c1wph0gj":"c1wph0gj","spinAround-c1wph0gj":"spinAround-c1wph0gj"};